import Button from 'components/actions/Button';
import type { Position } from 'components/map/types';
import Tooltip from 'components/overlays/Tooltip';
import { useState } from 'react';

import { parseWaypoints } from './parsers';

type Props = {
    onLoad: (positions: Position[]) => void;
};

const FORMAT_TOOLTIP = (
    <>
        <Tooltip.Header title='Supported formats' />
        <Tooltip.Content>
            <strong>Coordinate pairs</strong>
            <br />
            <code>{'[[lat, lng], ...]'}</code>
        </Tooltip.Content>
        <Tooltip.Divider />
        <Tooltip.Content>
            <strong>Object with position array</strong>
            <br />
            <code>{'[{ position: [lat, lng] }, ...]'}</code>
        </Tooltip.Content>
        <Tooltip.Divider />
        <Tooltip.Content>
            <strong>Object with lat/lng fields</strong>
            <br />
            <code>{'[{ latitude, longitude }, ...]'}</code>
        </Tooltip.Content>
    </>
);

const PasteWaypointsPanel = ({ onLoad }: Props) => {
    const [text, setText] = useState('');
    const [error, setError] = useState<string>();

    const handleLoad = () => {
        try {
            onLoad(parseWaypoints(text));
            setText('');
            setError(undefined);
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Parse error');
        }
    };

    return (
        <div className='PasteWaypointsPanel'>
            <div className='display-flex align-items-center justify-content-between margin-bottom-5'>
                <span className='text-color-gray'>Paste JSON waypoints</span>
                <Tooltip
                    placement='right'
                    trigger={
                        <span className='rioglyph rioglyph-question-sign text-color-gray text-14 cursor-pointer' />
                    }
                    width={300}
                >
                    {FORMAT_TOOLTIP}
                </Tooltip>
            </div>
            <textarea
                className='form-control'
                rows={6}
                placeholder='Paste JSON waypoints here…'
                value={text}
                onChange={e => setText(e.target.value)}
            />
            {error && <p className='text-color-danger margin-top-5'>{error}</p>}
            <Button
                style='primary'
                size='sm'
                className='margin-top-10 width-100pct'
                disabled={text.trim().length === 0}
                onClick={handleLoad}
            >
                Load waypoints
            </Button>
        </div>
    );
};

export default PasteWaypointsPanel;
